import React from "react";
import { BrowserRouter, Navigate, Route, Routes, useNavigate } from "react-router-dom";
import Login from "./components/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import AppShell from "./components/AppShell";
import ShopLayout from "./pages/ShopLayout";
import ShopHomePage from "./pages/ShopHomePage";
import ShopCategoryPage from "./pages/ShopCategoryPage";
import ShopCartPage from "./pages/ShopCartPage";
import ShopProductPage from "./pages/ShopProductPage";
import ShopStatusPage from "./pages/ShopStatusPage";
import DashboardPage from "./pages/DashboardPage";
import LeadsPage from "./pages/LeadsPage";
import OrdersPage from "./pages/OrdersPage";
import PmoPage from "./pages/PmoPage";
import CalendarPage from "./pages/CalendarPage";
import TechniciansPage from "./pages/TechniciansPage";
import CategoriesPage from "./pages/CategoriesPage";
import ProductsPage from "./pages/ProductsPage";
import WhatsAppPage from "./pages/WhatsAppPage";
import OdooSyncPage from "./pages/OdooSyncPage";
import SettingsPage from "./pages/SettingsPage";

function LoginRoute() {
  const navigate = useNavigate();
  return <Login onSuccess={() => navigate("/dashboard", { replace: true })} />;
}

function ShellRoutes() {
  return (
    <ProtectedRoute>
      <AppShell>
        <Routes>
          <Route path="/dashboard" element={<ProtectedRoute allowedRoles={["admin", "sales", "project_manager", "pmo", "technician"]}><DashboardPage /></ProtectedRoute>} />
          <Route path="/leads" element={<ProtectedRoute allowedRoles={["admin", "sales"]}><LeadsPage /></ProtectedRoute>} />
          <Route path="/orders" element={<ProtectedRoute allowedRoles={["admin", "sales", "project_manager", "pmo"]}><OrdersPage /></ProtectedRoute>} />
          <Route path="/pmo" element={<ProtectedRoute allowedRoles={["admin", "pmo"]}><PmoPage /></ProtectedRoute>} />
          <Route path="/calendar" element={<ProtectedRoute allowedRoles={["admin", "pmo"]}><CalendarPage /></ProtectedRoute>} />
          <Route path="/technicians" element={<ProtectedRoute allowedRoles={["admin", "pmo", "technician"]}><TechniciansPage /></ProtectedRoute>} />
          <Route path="/categories" element={<ProtectedRoute allowedRoles={["admin", "sales", "project_manager"]}><CategoriesPage /></ProtectedRoute>} />
          <Route path="/products" element={<ProtectedRoute allowedRoles={["admin", "sales", "project_manager"]}><ProductsPage /></ProtectedRoute>} />
          <Route path="/whatsapp" element={<ProtectedRoute allowedRoles={["admin", "sales", "project_manager", "pmo"]}><WhatsAppPage /></ProtectedRoute>} />
          <Route path="/odoo-sync" element={<ProtectedRoute allowedRoles={["admin", "project_manager"]}><OdooSyncPage /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute allowedRoles={["admin"]}><SettingsPage /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </AppShell>
    </ProtectedRoute>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/shop" element={<ShopLayout />}>
          <Route index element={<ShopHomePage />} />
          <Route path="category/:categoryId" element={<ShopCategoryPage />} />
          <Route path="cart" element={<ShopCartPage />} />
          <Route path="product/:productId" element={<ShopProductPage />} />
          <Route path="status" element={<ShopStatusPage />} />
        </Route>
        <Route path="/login" element={<LoginRoute />} />
        <Route path="/" element={<Navigate to="/shop" replace />} />
        <Route path="/*" element={<ShellRoutes />} />
      </Routes>
    </BrowserRouter>
  );
}
